import nullBind from 'utils/functions/nullBind.util';
import generateId from 'utils/values/generateId.util';

const FLOOR = 100000;
const RANGE = 899999;

const LONG = 'long';
const SHORT = 'short';

const randomString = type => {
  if (type === LONG) return generateId();

  // math in order to ensure same number of digits
  return `${FLOOR + Math.trunc(RANGE * Math.random())}`;
};

randomString.LONG = LONG;
randomString.SHORT = SHORT;

randomString.long = nullBind(randomString, LONG);
randomString.short = nullBind(randomString, SHORT);

export default randomString;
